import React from "react";

import { ValidationProvider } from "../../../contexts/ValidationContext";

import { Page } from "../../../containers/Page";
import { Navigation } from "../.././Navigation";
import { Content } from "../../../containers/Content";
import { MultiRadiosEntry } from "./MultiRadiosEntry";
import { PageBody } from "../../../containers/PageBody";
import { PageHeader } from "../../../containers/PageHeader";

export const MultiRadios = props =>
    <Page>
        <PageHeader />
        <PageBody>
            <Navigation />
            <Content>
                <ValidationProvider>
                    <MultiRadiosEntry entryId={props.entryId} />
                </ValidationProvider>
            </Content>
        </PageBody>
    </Page>;